const newsData = [
  {
    id: 1,
    name: "网易新闻",
    category: "新闻信息",
    icon: "📰",
    url: "https://news.163.com/",
    description: "网易新闻 - 有态度、有深度、有温度",
    color: "#E60026"
  },
  {
    id: 2,
    name: "新浪新闻",
    category: "新闻信息",
    icon: "🌐",
    url: "https://news.sina.com.cn/",
    description: "新浪新闻 - 全球资讯中文门户",
    color: "#E6162D"
  },
  {
    id: 3,
    name: "腾讯新闻",
    category: "新闻信息",
    icon: "🦊",
    url: "https://news.qq.com/",
    description: "腾讯新闻 - 事实派",
    color: "#07C160"
  },
  {
    id: 4,
    name: "央视新闻",
    category: "新闻信息",
    icon: "📺",
    url: "https://news.cctv.com/",
    description: "央视新闻 - 权威、及时、准确",
    color: "#004B97"
  },
  {
    id: 5,
    name: "人民日报",
    category: "新闻信息",
    icon: "📖",
    url: "http://www.people.com.cn/",
    description: "人民日报 - 权威、实力，源自人民",
    color: "#D32F2F"
  },
  {
    id: 6,
    name: "澎湃新闻",
    category: "新闻信息",
    icon: "🌊",
    url: "https://www.thepaper.cn/",
    description: "澎湃新闻 - 专注时政与思想",
    color: "#D81B60"
  },
  {
    id: 7,
    name: "界面新闻",
    category: "新闻信息",
    icon: "💼",
    url: "https://www.jiemian.com/",
    description: "界面新闻 - 商业与财经新闻平台",
    color: "#FF5722"
  },
  {
    id: 8,
    name: "虎嗅网",
    category: "新闻信息",
    icon: "🐯",
    url: "https://www.huxiu.com/",
    description: "虎嗅网 - 聚合优质的创新信息",
    color: "#FF9800"
  },
  {
    id: 9,
    name: "36氪",
    category: "新闻信息",
    icon: "🚀",
    url: "https://36kr.com/",
    description: "36氪 - 让一部分人先看到未来",
    color: "#009688"
  },
  {
    id: 10,
    name: "财新网",
    category: "新闻信息",
    icon: "💰",
    url: "https://www.caixin.com/",
    description: "财新网 - 原创财经新媒体",
    color: "#4CAF50"
  },
  {
    id: 11,
    name: "凤凰新闻",
    category: "新闻信息",
    icon: "🦚",
    url: "https://news.ifeng.com/",
    description: "凤凰新闻 - 中华情怀，全球视野",
    color: "#9C27B0"
  },
  {
    id: 12,
    name: "今日头条",
    category: "新闻信息",
    icon: "📱",
    url: "https://www.toutiao.com/",
    description: "今日头条 - 你关心的，才是头条",
    color: "#F44336"
  },
  {
    id: 13,
    name: "优酷视频",
    category: "视频平台",
    icon: "🎬",
    url: "https://www.youku.com/",
    description: "优酷 - 这世界很酷，阿里巴巴旗下视频平台",
    color: "#00B06C"
  },
  {
    id: 14,
    name: "腾讯视频",
    category: "视频平台",
    icon: "📹",
    url: "https://v.qq.com/",
    description: "腾讯视频 - 不负好时光，热门影视综艺独家播出",
    color: "#3196FA"
  },
  {
    id: 15,
    name: "AcFun",
    category: "视频平台",
    icon: "🔶",
    url: "https://www.acfun.cn/",
    description: "AcFun - 认真你就输啦，中国第一家弹幕视频网站",
    color: "#FD4C5D"
  },
  {
    id: 16,
    name: "Bilibili",
    category: "视频平台",
    icon: "📺",
    url: "https://www.bilibili.com/",
    description: "B站 - 哔哩哔哩干杯，年轻人喜爱的文化社区",
    color: "#FB7299"
  },
  {
    id: 17,
    name: "爱奇艺",
    category: "视频平台",
    icon: "🎥",
    url: "https://www.iqiyi.com/",
    description: "爱奇艺 - 悦享品质，百度旗下视频平台",
    color: "#00BE06"
  },
  {
    id: 18,
    name: "芒果TV",
    category: "视频平台",
    icon: "🥭",
    url: "https://www.mgtv.com/",
    description: "芒果TV - 看见好时光，湖南卫视旗下视频平台",
    color: "#FF7200"
  },
  
  // 新增的音乐平台
  {
    id: 19,
    name: "QQ音乐",
    category: "音乐平台",
    icon: "🎵",
    url: "https://y.qq.com/",
    description: "QQ音乐 - 音乐你的生活，海量正版曲库",
    color: "#31C27C"
  },
  {
    id: 20,
    name: "网易云音乐",
    category: "音乐平台",
    icon: "☁️",
    url: "https://music.163.com/",
    description: "网易云音乐 - 音乐的力量，个性化推荐",
    color: "#E60026"
  },
  {
    id: 21,
    name: "酷狗音乐",
    category: "音乐平台",
    icon: "🐕",
    url: "https://www.kugou.com/",
    description: "酷狗音乐 - 就是歌多，老牌音乐平台",
    color: "#00CCFF"
  },
  {
    id: 22,
    name: "酷我音乐",
    category: "音乐平台",
    icon: "🎶",
    url: "https://www.kuwo.cn/",
    description: "酷我音乐 - 好音质，海量高品质音乐",
    color: "#FF6A00"
  },
  {
    id: 23,
    name: "咪咕音乐",
    category: "音乐平台",
    icon: "🎤",
    url: "https://music.migu.cn/",
    description: "咪咕音乐 - 中国移动旗下，正版音乐平台",
    color: "#FF3A44"
  },
  
  // 新增的云存储平台
  {
    id: 24,
    name: "阿里云盘",
    category: "云存储",
    icon: "☁️",
    url: "https://www.aliyundrive.com/",
    description: "阿里云盘 - 速度快，不限速，安全可靠",
    color: "#FF6A00"
  },
  {
    id: 25,
    name: "百度网盘",
    category: "云存储",
    icon: "📦",
    url: "https://pan.baidu.com/",
    description: "百度网盘 - 你的文件管家，国内主流网盘",
    color: "#2932E1"
  },
  {
    id: 26,
    name: "腾讯微云",
    category: "云存储",
    icon: "💾",
    url: "https://www.weiyun.com/",
    description: "腾讯微云 - 安全可靠的云存储服务",
    color: "#07C160"
  },
  {
    id: 27,
    name: "坚果云",
    category: "云存储",
    icon: "🥜",
    url: "https://www.jianguoyun.com/",
    description: "坚果云 - 高效同步，团队协作",
    color: "#FFB300"
  },
  {
    id: 28,
    name: "OneDrive",
    category: "云存储",
    icon: "📁",
    url: "https://onedrive.live.com/",
    description: "OneDrive - 微软云存储，Office集成",
    color: "#0078D4"
  },
  {
    id: 29,
    name: "Google Drive",
    category: "云存储",
    icon: "🚀",
    url: "https://drive.google.com/",
    description: "Google Drive - 谷歌云端硬盘，高效协作",
    color: "#4285F4"
  },
  
  // 新增的其他实用网站
  {
    id: 30,
    name: "GitHub",
    category: "开发工具",
    icon: "🐙",
    url: "https://github.com/",
    description: "GitHub - 全球最大的代码托管平台",
    color: "#181717"
  },
  {
    id: 31,
    name: "Stack Overflow",
    category: "开发工具",
    icon: "🔍",
    url: "https://stackoverflow.com/",
    description: "Stack Overflow - 程序员问答社区",
    color: "#F48024"
  },
  {
    id: 32,
    name: "知乎",
    category: "社交媒体",
    icon: "💡",
    url: "https://www.zhihu.com/",
    description: "知乎 - 有问题，就会有答案",
    color: "#0084FF"
  },
  {
    id: 33,
    name: "豆瓣",
    category: "社交媒体",
    icon: "📚",
    url: "https://www.douban.com/",
    description: "豆瓣 - 书影音记录与分享社区",
    color: "#007722"
  },
  {
    id: 34,
    name: "小红书",
    category: "社交媒体",
    icon: "📕",
    url: "https://www.xiaohongshu.com/",
    description: "小红书 - 标记我的生活",
    color: "#FF2442"
  },
  {
    id: 35,
    name: "抖音",
    category: "视频平台",
    icon: "🎵",
    url: "https://www.douyin.com/",
    description: "抖音 - 记录美好生活",
    color: "#000000"
  },
  {
    id: 36,
    name: "微博",
    category: "社交媒体",
    icon: "🐦",
    url: "https://weibo.com/",
    description: "微博 - 随时随地发现新鲜事",
    color: "#E6162D"
  },
  {
    id: 37,
    name: "ChatGPT",
    category: "AI对话",
    icon: "🤖",
    url: "https://chatgpt.com/",
    description: "ChatGPT - OpenAI推出的智能对话助手，支持GPT-4o模型",
    color: "#10A37F"
  },
  {
    id: 38,
    name: "Claude",
    category: "AI对话",
    icon: "🧠",
    url: "https://claude.ai/",
    description: "Claude - Anthropic推出的AI助手，擅长长文本处理",
    color: "#D97706"
  },
  {
    id: 39,
    name: "文心一言",
    category: "AI对话",
    icon: "📝",
    url: "https://yiyan.baidu.com/",
    description: "文心一言 - 百度推出的知识增强型对话语言模型",
    color: "#2932E1"
  },
  {
    id: 40,
    name: "通义千问",
    category: "AI对话",
    icon: "💬",
    url: "https://tongyi.aliyun.com/",
    description: "通义千问 - 阿里达摩院推出的千亿参数大模型",
    color: "#FF6A00"
  },
  {
    id: 41,
    name: "豆包",
    category: "AI对话",
    icon: "🫘",
    url: "https://www.doubao.com/",
    description: "豆包 - 字节跳动为创作者打造的AI助手",
    color: "#00D4AA"
  },
  {
    id: 42,
    name: "智谱清言",
    category: "AI对话",
    icon: "🎯",
    url: "https://chatglm.cn/",
    description: "智谱清言 - 清华系智谱AI开发的多功能AI助手",
    color: "#2563EB"
  },
  {
    id: 43,
    name: "讯飞星火",
    category: "AI对话",
    icon: "✨",
    url: "https://xinghuo.xfyun.cn/",
    description: "讯飞星火 - 科大讯飞推出的AI大模型，支持语音交互",
    color: "#0066FF"
  },
  {
    id: 44,
    name: "Kimi",
    category: "AI对话",
    icon: "🌙",
    url: "https://kimi.moonshot.cn/",
    description: "Kimi - 月之暗面开发，支持200万字长文本处理",
    color: "#6366F1"
  },
  {
    id: 45,
    name: "DeepSeek",
    category: "AI对话",
    icon: "🔍",
    url: "https://chat.deepseek.com/",
    description: "DeepSeek - 深度求索推出的开源大模型",
    color: "#4B5563"
  },
  {
    id: 46,
    name: "Gemini",
    category: "AI对话",
    icon: "💎",
    url: "https://gemini.google.com/",
    description: "Gemini - Google推出的多模态AI助手",
    color: "#4285F4"
  },
  {
    id: 47,
    name: "Grok",
    category: "AI对话",
    icon: "🚀",
    url: "https://grok.com/",
    description: "Grok - xAI（马斯克）推出的AI模型，实时访问X数据",
    color: "#000000"
  },
  
  // AI绘画工具
  {
    id: 48,
    name: "Midjourney",
    category: "AI绘画",
    icon: "🎨",
    url: "https://www.midjourney.com/",
    description: "Midjourney - 艺术表现力顶尖的AI图像生成工具",
    color: "#663399"
  },
  {
    id: 49,
    name: "Stable Diffusion",
    category: "AI绘画",
    icon: "🖼️",
    url: "https://stability.ai/",
    description: "Stable Diffusion - 开源免费的AI绘画模型，支持本地部署",
    color: "#FF6B35"
  },
  {
    id: 50,
    name: "DALL-E 3",
    category: "AI绘画",
    icon: "🎭",
    url: "https://openai.com/dall-e-3",
    description: "DALL-E 3 - OpenAI推出的文本到图像AI模型",
    color: "#10A37F"
  },
  {
    id: 51,
    name: "文心一格",
    category: "AI绘画",
    icon: "🖌️",
    url: "https://yige.baidu.com/",
    description: "文心一格 - 百度推出的AI艺术和创意辅助平台",
    color: "#2932E1"
  },
  {
    id: 52,
    name: "即梦AI",
    category: "AI绘画",
    icon: "🎬",
    url: "https://jimeng.jianying.com/",
    description: "即梦AI - 字节跳动推出的一站式AI创作平台",
    color: "#00D4AA"
  },
  {
    id: 53,
    name: "奇域AI",
    category: "AI绘画",
    icon: "🏮",
    url: "https://www.qiyuai.net/",
    description: "奇域AI - 小红书推出的国风专属AI作画工具",
    color: "#FF2442"
  },
  {
    id: 54,
    name: "LiblibAI",
    category: "AI绘画",
    icon: "🎪",
    url: "https://www.liblib.art/",
    description: "LiblibAI - 国内最大的Stable Diffusion生态平台",
    color: "#8B5CF6"
  },
  
  // AI编程工具
  {
    id: 55,
    name: "GitHub Copilot",
    category: "AI编程",
    icon: "👨‍💻",
    url: "https://github.com/features/copilot",
    description: "GitHub Copilot - GitHub与OpenAI联合打造的智能代码补全助手",
    color: "#181717"
  },
  {
    id: 56,
    name: "Cursor",
    category: "AI编程",
    icon: "⌨️",
    url: "https://www.cursor.com/",
    description: "Cursor - AI驱动的全新IDE，内置Agent跨文件分析",
    color: "#0078D4"
  },
  {
    id: 57,
    name: "CodeGeeX",
    category: "AI编程",
    icon: "💻",
    url: "https://codegeex.cn/",
    description: "CodeGeeX - 智谱AI推出的代码生成工具",
    color: "#2563EB"
  },
  {
    id: 58,
    name: "通义灵码",
    category: "AI编程",
    icon: "🔧",
    url: "https://tongyi.aliyun.com/lingma",
    description: "通义灵码 - 阿里云推出的AI代码助手",
    color: "#FF6A00"
  },
  
  // AI搜索工具
  {
    id: 59,
    name: "Perplexity",
    category: "AI搜索",
    icon: "🔍",
    url: "https://www.perplexity.ai/",
    description: "Perplexity - 对话式AI搜索引擎，实时联网+引用溯源",
    color: "#20808D"
  },
  {
    id: 60,
    name: "Grok搜索",
    category: "AI搜索",
    icon: "🌐",
    url: "https://grok.com/",
    description: "Grok - 实时访问X平台的AI搜索工具",
    color: "#000000"
  },
  
  // AI视频工具
  {
    id: 61,
    name: "Runway",
    category: "AI视频",
    icon: "🎥",
    url: "https://runwayml.com/",
    description: "Runway - 专业的AI视频生成和编辑平台",
    color: "#FF4D4D"
  },
  {
    id: 62,
    name: "Sora",
    category: "AI视频",
    icon: "🎞️",
    url: "https://openai.com/sora",
    description: "Sora - OpenAI推出的文本生成视频AI模型",
    color: "#10A37F"
  },
  {
    id: 63,
    name: "即梦视频",
    category: "AI视频",
    icon: "🎬",
    url: "https://jimeng.jianying.com/",
    description: "即梦视频 - 字节跳动的AI视频生成工具",
    color: "#00D4AA"
  },
  
  // AI音频工具
  {
    id: 64,
    name: "Suno AI",
    category: "AI音频",
    icon: "🎵",
    url: "https://suno.com/",
    description: "Suno AI - 文本生成音乐的AI工具",
    color: "#FF6B35"
  },
  {
    id: 65,
    name: "讯飞听见",
    category: "AI音频",
    icon: "🎙️",
    url: "https://www.iflyrec.com/",
    description: "讯飞听见 - 科大讯飞的语音转文字服务",
    color: "#0066FF"
  },
  
  // AI设计工具
  {
    id: 66,
    name: "Canva AI",
    category: "AI设计",
    icon: "✏️",
    url: "https://www.canva.com/",
    description: "Canva AI - 集成AI功能的在线设计平台",
    color: "#00C4CC"
  },
  {
    id: 67,
    name: "Figma AI",
    category: "AI设计",
    icon: "🎨",
    url: "https://www.figma.com/",
    description: "Figma AI - Figma的AI辅助设计功能",
    color: "#F24E1E"
  },
  
  // AI办公工具
  {
    id: 68,
    name: "Notion AI",
    category: "AI办公",
    icon: "📋",
    url: "https://www.notion.so/",
    description: "Notion AI - 集成AI的笔记和协作平台",
    color: "#000000"
  },
  {
    id: 69,
    name: "Gamma",
    category: "AI办公",
    icon: "📊",
    url: "https://gamma.app/",
    description: "Gamma - AI驱动的演示文稿生成工具",
    color: "#8B5CF6"
  },
  {
    id: 70,
    name: "飞书AI",
    category: "AI办公",
    icon: "🚀",
    url: "https://www.feishu.cn/",
    description: "飞书AI - 字节跳动的智能办公平台",
    color: "#00D4AA"
  }
];

// 获取所有新闻分类
const getNewsCategories = () => {
  const categories = [...new Set(newsData.map(item => item.category))];
  return categories;
};

// 按分类获取新闻网站
const getNewsByCategory = (category) => {
  return newsData.filter(item => item.category === category);
};

// 按ID获取新闻网站
const getNewsById = (id) => {
  return newsData.find(item => item.id === parseInt(id));
};

export { newsData, getNewsCategories, getNewsByCategory, getNewsById };
